import { default as AkFlag } from '@atlaskit/flag/flag';
import type { FlagProps as AkFlagProps } from '@atlaskit/flag/types';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Flag: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AkFlagProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<AkFlagProps>(AkFlag);
